const sendFitmentComplaintToZendesk = /* GraphQL */ `
  query sendFitmentComplaintToZendesk($input: EngineFitmentComplaintInput) {
    sendFitmentComplaintToZendesk(input: $input) {
      success
      message
    }
  }
`

export default sendFitmentComplaintToZendesk
